import Textarea from './textarea.vue';

export default Textarea;


// WEBPACK FOOTER //
// ./src/components/inputs/textarea/index.js